<template>
    <div id="main-content" class="parent-list">
        <el-col :offset="1" :span="22">
            <PageTitle :title="title" :backLink="backLink"></PageTitle>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="$t('common.pickup_route')" name="pickupTemplate">
                <el-row>
                  <el-form :inline="true" class="demo-form-inline">
                    <el-form-item>
                      <el-button type="success" @click="goToAddTemplate(1)">+ {{ $t('moreLanguage.add_template') }}</el-button>
                    </el-form-item>
                  </el-form>
                </el-row>
                <template v-if="dataPickup">
                  <el-row style="padding-top: 20px">
                    <table class="bus-list filter-sort-table">
                      <tr>
                        <th width="5%">#</th>
                        <th class="input-th">
                          {{$t('common.title')}}
                        </th>
                        <th>{{$t('templateDefault')}}</th>
                        <th  class="input-th"> {{$t('moreLanguage.createdAt')}}</th>
                        <th  class="input-th"> {{$t('common.note')}}</th>
                        <th width="17%">
                        </th>
                      </tr>
                      <tr v-for="(temp, index) in dataPickup.data" :key="temp.id">
                        <td>{{ index + 1 }}</td>
                        <td class="text-left pl-4">{{ temp.name }}</td>
                        <td>{{temp.default ? $t('log.statusError.yes'): $t('log.statusError.no')}}</td>
                        <td>{{ temp.created_at }}</td>
                        <td>{{ temp.note }}</td>
                        <td>
                          <b-button variant="outline-primary" @click="onShowDetailTemplate(temp.id)"  style="margin-right: 10px">
                            {{ $t('common.detail') }}
                          </b-button>
                          <b-button variant="danger" @click="onDeletePickupTemplate(temp.id)" >{{ $t('common.delete') }}</b-button>
                        </td>
                      </tr>
                    </table>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-pagination
                        v-show="dataPickup.total > dataPickup.per_page"
                        background
                        @current-change="didSelectPagePickup"
                        :page-size="10"
                        layout="prev, pager, next"
                        :current-page="pagePickup"
                        :total="dataPickup.total">
                    </el-pagination>
                  </el-row>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('common.drop_route')" name="dropTemplate">
                <el-row>
                  <el-form :inline="true" class="demo-form-inline">
                    <el-form-item>
                      <el-button type="success" @click="goToAddTemplate(2)">+ {{ $t('moreLanguage.add_template') }}</el-button>
                    </el-form-item>
                  </el-form>
                </el-row>
                <template v-if="data">
                  <el-row style="padding-top: 20px">
                    <table class="bus-list filter-sort-table">
                      <tr>
                        <th width="5%">#</th>
                        <th class="input-th">
                          {{$t('common.title')}}
                        </th>
                        <th  class="input-th"> {{$t('moreLanguage.createdAt')}}</th>
                        <th  class="input-th"> {{$t('common.note')}}</th>
                        <th width="17%">
                        </th>
                      </tr>
                      <tr v-for="(temp, index) in data.data" :key="temp.id">
                        <td>{{ index + 1 }}</td>
                        <td class="text-left pl-4">{{ temp.name }}</td>
                        <td>{{ temp.created_at }}</td>
                        <td>{{ temp.note }}</td>
                        <td>
                          <b-button variant="outline-primary" @click="goToDetailParent(temp.id)" style="margin-right: 10px">
                            {{ $t('common.detail') }}
                          </b-button>
                          <b-button variant="danger" @click="deleteParent(temp.id)">{{ $t('common.delete') }}</b-button>
                        </td>
                      </tr>
                    </table>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-pagination
                        v-show="data.total > data.per_page"
                        background
                        @current-change="didSelectPage"
                        :page-size="data.per_page"
                        layout="prev, pager, next"
                        :current-page="page"
                        :total="data.total">
                    </el-pagination>
                  </el-row>
                </template>
              </el-tab-pane>
            </el-tabs>
        </el-col>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import PageTitle from '@/components/PageTitle'

    export default {
        name: 'TemplateList',
        components: {
            PageTitle
        },
        data: function () {
            return {
                backLink: ``,
                title: 'moreLanguage.templateList',
                page: 1,
                pagePickup:1,
                isBack: false,
                data: null,
                dataPickup:null,
                filterTimeout: null,
                activeName:"pickup"
            }
        },
        methods: {
            goToAddTemplate: function (type =1) {
              if(type ===1 ){
                this.$router.push('/schedule/add-template-pickup')
              }else{
                this.$router.push('/schedule/add-template/')
              }

            },
            handleClick(){

            },
          onGetListPickupTemplate(){
            let payload = {
              successCallback: (response) => {
                if(response.status ===200){
                  this.dataPickup = Object.assign({}, response.data.data.data_list)
                }
              },
              errorCallback: () => {},
              page: this.pagePickup
            }
            this.$store.dispatch('pickupTemplate/getListPickupTemplate', payload)
          },
            goToDetailParent(parentId) {
                this.$router.push({path: '/schedule/add-template', query: {tid: parentId}});
            },
            didSelectPage: function (e) {
                this.page = e
                this.retrieveData()
            },
            didSelectPagePickup(e){
                this.pagePickup = e
                this.onGetListPickupTemplate()
            },
            deleteParent(parentId) {
                this.$store.commit('openConfirm', {
                    title: this.$t('common.delete'),
                    message: this.$t('moreLanguage.template_delete_confirm'),
                    callback: () => {
                        let payload = {
                            id: parentId,
                            successCallback: () => {
                                if (this.data.data.length <= 1) {
                                    this.page = this.page > 1 ? this.page - 1 : 1
                                }

                                this.retrieveData()
                            }
                        }

                        this.$store.dispatch('schedule/deleteTemplate', payload)
                    }
                })
            },
            retrieveData: function () {
                let filter = this.filter
                let sort = this.sort
                let page = this.page
                let successCallback = (response) => {
                    this.data = Object.assign({}, response.data.data.template_list)
                }

                this.$store.dispatch('schedule/retrieveTemplateList', {
                    filter, sort, page, successCallback
                })
            },
          onShowDetailTemplate(tempId){
            this.$router.push({path: '/schedule/add-template-pickup', query: {tid: tempId}});
          },
          onDeletePickupTemplate(tempId){
            this.$store.commit('openConfirm', {
              title: this.$t('common.delete'),
              message: this.$t('moreLanguage.template_delete_confirm'),
              callback: () => {
                let payload = {
                  template_id: tempId,
                  successCallback: () => {
                    if (this.dataPickup.data.length <= 1) {
                      this.pagePickup = this.pagePickup > 1 ? this.pagePickup - 1 : 1
                    }
                    this.onGetListPickupTemplate()
                  }
                }
                this.$store.dispatch('pickupTemplate/deletePickupTemplate', payload)
              }
            })
          }
        },
        created: function () {
            this.onGetListPickupTemplate()
            if (this.$route.query.action && this.$route.query.action === "back") {
                if (this.currentFilter) {
                    this.filter = Object.assign({}, this.currentFilter)
                    this.isBack = true
                }

                if (this.currentSort) {
                    this.sort = Object.assign({}, this.currentSort)
                }

                if (this.currentPage) {
                    this.page = this.currentPage
                }
            }

            this.$store.commit('parent/updateState', {
                filter: null,
                sort: null,
                page: null
            })
        },
        mounted: function () {
            this.retrieveData()
            if(this.$route.query.isType==='drop'){
              this.activeName = 'dropTemplate'
            }else{
              this.activeName = 'pickupTemplate'
            }
        },
        computed: {
            ...mapState('parent', ['currentFilter', 'currentSort', 'currentPage'])
        },
        watch: {
            filter: {
                deep: true,
                handler: function () {
                    if (this.isBack) {
                        this.isBack = false
                        return
                    }

                    clearTimeout(this.filterTimeout)
                    this.filterTimeout = setTimeout(() => {
                        this.retrieveData()
                    }, 1000)

                    this.page = 1
                }
            }
        }
    }
</script>
<style lang="scss">
    .bus-list {
        width: 100%;
        /*border: 1px solid #DCDFE6;*/
    }

    table, th, td {
        border: 1px solid #DCDFE6;
        border-collapse: collapse;
    }

    th {
        height: 55px;
        background-color: rgba(0, 0, 0, 0.2);
        color: #fff;
    }

    td {
        height: 40px;
    }
</style>
